import img1 from "../../src/components/resources/images/sliderItems/1.jpg";
import img2 from "../../src/components/resources/images/sliderItems/2.jpg";
import img3 from "../../src/components/resources/images/sliderItems/3.jpg";
import img4 from "../../src/components/resources/images/sliderItems/4.jpg";
import img5 from "../../src/components/resources/images/sliderItems/5.jpg";

export const SLIDER_ITEMS = [img1, img2, img3, img4, img5];